import { render, staticRenderFns } from "./filter-multi-select.vue?vue&type=template&id=bec450f0&scoped=true"
import script from "./filter-multi-select.vue?vue&type=script&lang=js"
export * from "./filter-multi-select.vue?vue&type=script&lang=js"
import style0 from "./filter-multi-select.vue?vue&type=style&index=0&id=bec450f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec450f0",
  null
  
)

export default component.exports